import React from 'react';

import { Modal, SystemText } from 'e4shared';
import TaskList from 'components/tasks/taskList';

export const CompetencyTasks = ({ competency, profile, show, close, summary, modalInModal }) => {
    if (!competency || !profile) return null;

    return (
        <Modal
            key={profile.id}
            show={show}
            title={SystemText('User121/Competencies/Buttons/ViewObjectives/Title', profile?.full_Name, competency.name)}
            close={close}
            footer={null}
            modalInModal={modalInModal}
        >
            <TaskList renderOutOfBox profileId={profile?.id} competencyId={competency?.id} summary={summary} compRating />
        </Modal>
    );
};

export default CompetencyTasks;
